<template>
  <div>
    <v-layout
      row
      align-center
      :style="myLayoutStyle"
    >
      <v-flex
        xs12
        sm10
        offset-sm1
        md10
        offset-md1
        lg10
        offset-lg1
        xl8
        offset-xl2
      >
        <v-card
          flat
          :color="theme.bg_color"
        >
          <v-card-text>
            <v-layout>
            <page-title :title="voucher.name" /><br>
            </v-layout>
            <v-layout>
            <span style="font-size: smaller;color: #9e9e9e" v-if="voucher.expiry_date && voucher.expiry_date !== '0000-00-00 00:00:00'">
            Valid till: {{ formatDate(voucher.expiry_date) }}
            </span>
              <v-spacer></v-spacer>
            <span style="font-size: smaller;color: #9e9e9e" v-if="voucher.used && voucher.gems_member_voucher !== '1'">
            Used: {{ formatDate(voucher.used) }}
            </span>
            </v-layout>
            <v-layout>
            <v-img
              :src="voucher.image"
              height="180"
              contain
            >
            </v-img>
            </v-layout>
          </v-card-text>
          <div
            v-if="voucher.gems_member_voucher.Description"
            class="mt-3 pa-3"
            :style="tncStyle"
          >
<!--            <span class="tnc-title">Description</span>-->
            <p class="tnc"
              v-html="voucher.gems_member_voucher.Description">
            </p>
          </div>
          <div
            class="mt-3 pa-3"
            :style="tncStyle"
          >
            <span class="tnc-title">Conditions</span>
            <v-card-text class="pt-0 condition" v-if="voucher.gems_member_voucher.DineMode">
              <!--  Dine Mode -->
              <v-layout>
                <v-flex xs1>
                  <v-icon
                    class="middle"
                    small
                    :color="fulfilledIcon(checkDineMode()).color"
                  >
                    {{ fulfilledIcon(checkDineMode()).icon }}
                  </v-icon>
                </v-flex>
                <v-flex xs4
                >
                  <span :style="fulfilledStyle(checkDineMode())">Dine Mode:</span>
                </v-flex>
                <v-flex xs7
                >
                  <span :style="fulfilledStyle(checkDineMode())">{{ formatDineMode(voucher.gems_member_voucher.DineMode) }}</span>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-text class="pt-0 condition" v-if="voucher.gems_member_voucher.MinBillAmount">
              <!--  Min Bill Amount -->
              <v-layout>
                <v-flex xs1>
                  <v-icon
                    class="middle"
                    small
                    :color="fulfilledIcon(checkMinimum()).color"
                  >
                    {{ fulfilledIcon(checkMinimum()).icon }}
                  </v-icon>
                </v-flex>
                <v-flex xs4
                >
                  <span :style="fulfilledStyle(checkMinimum())">Min Amount:</span>
                </v-flex>
                <v-flex xs7
                >
                  <span :style="fulfilledStyle(checkMinimum())">S$ {{ voucher.gems_member_voucher.MinBillAmount }}</span>
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-text class="pt-0 condition">
              <!--  Stackable -->
              <v-layout>
                <v-flex xs1>
                  <v-icon
                    class="middle"
                    small
                    :color="fulfilledIcon(checkStack()).color"
                  >
                    {{ fulfilledIcon(checkStack()).icon }}
                  </v-icon>
                </v-flex>
                <v-flex xs4
                >
                  <span :style="fulfilledStyle(checkStack())">Stackable:</span>
                </v-flex>
                <v-flex xs7
                >
                  <span :style="fulfilledStyle(checkStack())">{{ voucher.gems_member_voucher.Stackable ? 'Yes' : 'No' }}</span>
                </v-flex>
              </v-layout>
            </v-card-text>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
    <v-footer
      fixed
      app
      inset
      :height="theme.footer_height"
      :color="theme.footer_bg_color"
    >
      <v-btn
        v-if="!applied"
        block
        dark
        large
        class="btn"
        :color="theme.btn_color_primary"
        :disabled="!checkConditions()"
      >
        <v-layout row>
          <v-flex
            xs12
            class="text-xs-center"
            @click="applyCoupon"
          >
            {{ $t('apply') }}
          </v-flex>
        </v-layout>
      </v-btn>
      <v-btn
        v-else
        block
        dark
        large
        class="btn"
        :color="theme.btn_color_primary"
      >
        <v-layout row>
          <v-flex
            xs12
            class="text-xs-center"
            @click="removeCoupon"
          >
            {{ $t('remove') }}
          </v-flex>
        </v-layout>
      </v-btn>
    </v-footer>
    <feedback-message />
    <v-dialog
      v-model="showQR"
      width="300"
    >
        <img style="text-align: center" alt="Voucher QR" :src="generateQR" title="VoucherQR" />
    </v-dialog>
    <voucher-item-dialog v-if="isMember && voucherItemDialog && !(iOS && inIframe)" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageTitle from '~/components/PageTitle'
import VueScrollTo from 'vue-scrollto'
import FeedbackMessage from '../components/FeedbackMessage'
import moment from 'moment'
import axios from 'axios'
import VoucherItemDialog from '../components/VoucherItemDialog'

export default {
  name: 'voucher',
  data () {
    return {
      voucherQr: null,
      showQR: false
    }
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  components: {
    FeedbackMessage,
    'page-title': PageTitle,
    'voucher-item-dialog': VoucherItemDialog
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'mode', 'iOS', 'inIframe'
    ]),
    ...mapGetters('voucher', [
      'vouchers', 'voucherItemDialog', 'promotionVoucher'
    ]),
    ...mapGetters('cart', [
      'cartAmount', 'cart'
    ]),
    ...mapGetters('cart', {
      cartVoucher: 'vouchers'
    }),
    ...mapGetters('menu', [
      'menuItem', 'menuItemPrice', 'menuItemQty',
      'menuItemReady', 'menuItemCourseItems', 'menuItemOptions',
      'menuItemToppings', 'menuItemRequired'
    ]),
    ...mapGetters('member', [
      'isMember'
    ]),
    voucher () {
      return this.vouchers.find(v => parseInt(v.id) === parseInt(this.id))
    },
    myLayoutStyle () {
      return {
        marginLeft: '-8px',
        marginRight: '-8px',
        marginBottom: '-16px',
        backgroundColor: this.theme.bg_color
      }
    },
    aboutStyle () {
      return {
        fontSize: '13px',
        color: this.theme.title_color
      }
    },
    tncStyle () {
      return {
        color: this.theme.title_color
      }
    },
    applied () {
      return this.cartVoucher.find(v => v.member_voucher_id === this.voucher.id) || false
    },
    generateQR () {
      return "https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=" + this.voucherQr
    }
  },
  methods: {
    formatDate (date) {
      const d = moment(date)
      return d.format('YYYY-MM-DD')
      // const d = new Date(date)
      // const month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)
      // const day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
      // return d.getFullYear() + '-' + month + '-' + day
    },
    formatDineMode (dineModes) {
      let modes = JSON.parse(dineModes).map(m => {
        if (parseInt(m) === 1) return 'Dine In'
        if (parseInt(m) === 2) return 'Takeaway'
        if (parseInt(m) === 3) return 'Delivery'
      })

      return modes.toString()
    },
    fulfilledStyle (v) {
      let styles = {
        fontSize: '14px',
      }
      if (v) {
        styles.color = this.theme.orders_success_color
      } else {
        styles.color = this.theme.orders_fail_color
      }
      return styles
    },
    fulfilledIcon (v) {
      return {
        icon: v ? 'fas fa-check' : 'fas fa-times',
        color: v ? this.theme.orders_success_color : this.theme.orders_fail_color
      }
    },
    checkConditions () {
      return this.checkDineMode() && this.checkMinimum() && this.checkStack() && this.checkUnlimitedUse()
    },
    checkUnlimitedUse () {
      return this.voucher.gems_member_voucher.UnlimitedUse || (!this.voucher.gems_member_voucher.UnlimitedUse && !this.voucher.used)
    },
    checkDineMode () {
      let currentMode
      if (this.mode.isDinein) currentMode = '1'
      if (this.mode.isTakeaway) currentMode = '2'
      if (this.mode.isDelivery) currentMode = '3'

      const dineModeJson = JSON.parse(this.voucher.gems_member_voucher.DineMode)
      return dineModeJson ? dineModeJson.includes(currentMode) : true
    },
    checkMinimum () {
      let minAmt = parseInt(this.voucher.gems_member_voucher.MinBillAmount)
      return minAmt > 0 ? parseInt(this.cartAmount) > minAmt : true
    },
    checkStack () {
      if (this.applied) { //applied
        if (!this.voucher.gems_member_voucher.Stackable) { //cannot stack
          return this.cartVoucher.length === 0
        } else { // can stack
          // check cart voucher allow stack
          const appliedVoucher = this.vouchers.find(v => v.voucher_id === this.cartVoucher[0].voucher_id )
          return !!appliedVoucher.gems_member_voucher.Stackable
        }
      } else { // not applied
        if (this.voucher.gems_member_voucher.Stackable) { //cannot stack
          return this.cartVoucher.length === 0
        } else { //can stack
          // check cart voucher allow stack
          if (this.cartVoucher.length > 0) { // other voucher applied
            const appliedVoucher = this.vouchers.find(v => v.voucher_id === this.cartVoucher[0].voucher_id )
            return !!appliedVoucher.gems_member_voucher.Stackable
          } else { // no voucher applied
            return true
          }
        }
      }
    },
    async applyCoupon () {
      if (this.mode.paymentMode === 1 && this.voucher.gems_member_voucher.VoucherType === 0) {
        this.showQR = true
      } else {
        if (this.voucher.item.has_courses) { // item has courses
          this.$bus.$emit('showFullLoading', true)
          await this.$store.dispatch('menu/fetchCatItems', this.voucher.item.category_id)
          await this.$store.dispatch('voucher/setPromotionVoucher', this.voucher)
          this.$bus.$emit('showFullLoading', false)
          if (this.promotionVoucher.voucher_id && this.cart.find(item => item.voucher_id === this.promotionVoucher.voucher_id)) {
            const text = 'You already used this voucher in your basket.'
            this.$store.dispatch('responseMessage', {
              type: 'error',
              title: 'One redemption per member',
              text: text,
              modal: true
            })
            return
          } else {
            this.$store.dispatch('voucher/showVoucherItemDialog', this.menuItem)
          }
        } else {
          await this.$store.dispatch('voucher/setPromotionVoucher', this.voucher)
          const gv = this.voucher.gems_member_voucher
          if (parseInt(gv.VoucherType) === 1) {
            if (this.menuItemReady === null) {
              await this.$store.dispatch('menu/processMenuItem', 'both')
            }
            if (this.menuItemReady === false) {
              this.$store.dispatch('responseMessage', {
                type: 'error',
                text: 'Please select: ' + this.menuItemRequired.join(', '),
                title: 'Please complete selection',
                modal: true
              })
              const options = {
                container: '#promotion-dialog-content',
                easing: 'ease-in',
                offset: -20,
                force: true,
                cancelable: false,
                x: false,
                y: true
              }
              const element = '#' + this.menuItemRequired[0].replace(/\s+/g, '-').toLowerCase()
              VueScrollTo.scrollTo(element, 500, options)
              return
            }
            const params = {
              voucher_id: this.voucher.voucher_id,
              member_voucher_id: this.voucher.id,
              item: this.menuItem,
              quantity: this.menuItemQty,
              final_price: this.menuItemPrice,
              options: this.menuItemOptions,
              toppings: this.menuItemToppings,
              set_course_items: this.menuItemCourseItems
            }
            await this.$store.dispatch('cart/addCartItem', params)
            await this.$router.push({ name: 'cart' })
            await this.$store.dispatch('responseMessage', {
              type: 'success',
              text: 'Promotion item added to cart.',
              timeout: 10000
            })
          } else {
            await this.$store.dispatch('order/enableUseVouchers')
            await this.$store.dispatch('cart/addCartVoucher', this.voucher.voucher_id)
            await this.$store.dispatch('responseMessage', {
              type: 'success',
              text: 'Voucher apply successfully.',
              timeout: 10000
            })
          }
        }
      }
    },
    async removeCoupon () {
      await this.$store.dispatch('cart/removeCartVoucher', this.voucher.voucher_id)
      const gv = this.voucher.gems_member_voucher
      if (parseInt(gv.VoucherType) === 1) {
        let item = this.cart.find(item => parseInt(item.voucher_id) === parseInt(this.voucher.voucher_id))
        // remove item from cart
        await this.$store.dispatch('cart/removeCartItem', item.cart_id)
      }
      await this.$store.dispatch('responseMessage', {
        type: 'success',
        text: 'Voucher removed from cart successfully.',
        timeout: 10000
      })
    },
  },
  async beforeMount () {
    // if pay after serve
    if (this.mode.paymentMode === 1) {
      // get qr string from api
      await axios.post('/api/voucher/qr', {
        voucher_id: this.voucher.id,
        member_id: this.voucher.member_id,
        group_id: this.voucher.group_id,
        expiry: 600
      }).then(response => {
        // set to this.voucherQr
        if (response.data.code) this.voucherQr = response.data.qr
        else console.log(response.data)
      })
    }
  }
}
</script>

<style scoped>
.tnc-title {
  text-transform: uppercase;
  font-weight: 800;
  font-size: 14px;
}
.condition {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/pages/voucher.vue